<template>
    <div class="library-satalia-filters" data-testid="library-satalia-filters">
        <CollapsibleWidget>
            <template #name>Pre-flight</template>

            <RadioGroup v-model="sataliaStatusFilter" vertical>
                <Radio
                    v-for="sataliaOption in sataliaOptions"
                    :key="sataliaOption.value"
                    :label="sataliaOption.value"
                    class="satalia-options"
                    @click.stop.prevent="onChangeSatalia(sataliaOption.value)"
                >
                    {{ sataliaOption.label }}
                </Radio>
            </RadioGroup>
        </CollapsibleWidget>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useStore } from "vuex";

import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";

import { PreflightStatusFilters } from "@/enums/platforms";

import { type RootState } from "@/store";
import { DeliverableLibraryAction, DeliverableLibraryGetters } from "@/store/modules/deliverableLibrary";

const SataliaStatusFiltersLabels = {
    [PreflightStatusFilters.All]: "All",
    [PreflightStatusFilters.NotSent]: "Not Sent",
    [PreflightStatusFilters.Error]: "Error",
    [PreflightStatusFilters.Processing]: "Processing",
    [PreflightStatusFilters.Completed]: "Completed"
};

const sataliaOptions = Object.values(PreflightStatusFilters).map(value => ({
    label: SataliaStatusFiltersLabels[value],
    value
}));

const store = useStore<RootState>();

const sataliaStatusFilter = computed<string>({
    get: () => {
        return store.getters[DeliverableLibraryGetters.sataliaStatusFilters];
    },
    set: newValue => {
        store.dispatch(DeliverableLibraryAction.UpdateSataliaStatusFilter, newValue);
    }
});

const onChangeSatalia = (value: string) => {
    sataliaStatusFilter.value = value;
};
</script>

<style lang="scss" scoped>
.library-satalia-filters {
    .ivu-radio-group {
        display: block;
    }

    .ivu-radio-wrapper {
        height: max-content;
        line-height: normal;
    }

    .satalia-options {
        padding-left: 50px;
    }
}
</style>
